/**
 * Preços de número adicional / avulso Voice (fonte única para UI).
 * Manter alinhado com supabase/functions/create-stripe-checkout (VOICE_EXTRA_*).
 *
 * - Base (Starter ou avulso sem Pro ativo): R$ 56 / mês por número
 * - Tier Pro (plano Pro ou avulso com assinatura Voice Pro ativa): R$ 50 / mês por número
 */

export const VOICE_EXTRA_NUMBER_BASE_BRL = 56
export const VOICE_EXTRA_NUMBER_PRO_BRL = 50

const PRO_MONTHLY =
  import.meta.env.VITE_VOICE_PLAN_PRO_PRICE_ID || 'price_1TF7QOE9Nnliuzv1Xn4FnYkL'
const PRO_ANNUAL =
  import.meta.env.VITE_VOICE_PLAN_PRO_ANNUAL_PRICE_ID || 'price_1TF7QOE9Nnliuzv1aJ03Vs9l'

/** IDs Stripe dos preços do plano Voice Pro (mensal + anual). */
export const VOICE_PRO_STRIPE_PRICE_IDS = [PRO_MONTHLY, PRO_ANNUAL].filter(Boolean)

/**
 * Preço unitário para exibição no app (perfil + plano no Supabase).
 * O valor cobrado no Stripe é definido na Edge Function (assinaturas Stripe).
 */
export function getVoiceExtraUnitPriceBrlForDisplay({ planStripePriceId, planStatus } = {}) {
  const active = ['active', 'trialing'].includes(String(planStatus || '').toLowerCase())
  if (!active || !planStripePriceId) return VOICE_EXTRA_NUMBER_BASE_BRL
  if (VOICE_PRO_STRIPE_PRICE_IDS.includes(planStripePriceId)) return VOICE_EXTRA_NUMBER_PRO_BRL
  return VOICE_EXTRA_NUMBER_BASE_BRL
}

export const VOICE_PRICING_HELP = {
  baseLabel: 'Preço base (Plano Starter ou avulso)',
  baseValue: VOICE_EXTRA_NUMBER_BASE_BRL,
  proLabel: 'Preço a partir do plano Pro (Plano Pro ou avulso com plano Pro ativo)',
  proValue: VOICE_EXTRA_NUMBER_PRO_BRL,
}
